import { getStakesSuccess, getStakesError } from "./stakes.slice";
import { StaticStakes } from "../../constants/StaticStakes";
import { toastr } from "react-redux-toastr";
import httpAuth from "../../services/httpAuth";

export const requestStakeButtons = () => async (dispatch, getState) => {
  const checkAuth = getState().auth;

  try {
    if (!checkAuth) return 
    const response = await httpAuth.post("/user/getUserMatchStack", {});
    if (response?.data?.status) {
      dispatch(getStakesSuccess(response?.data?.match_stack));
    } else {
      dispatch(getStakesSuccess(StaticStakes));
    }
  } catch (e) {
    dispatch(getStakesSuccess(StaticStakes));
    //   dispatch(getStakesError())
  }
};

export const requestUpdateStakeButtons = (data) => async (
  dispatch,
  getState
) => {
  const auth = getState().auth;

  try {
    if (auth) {
      const payload = {
        match_stack: data,
      };
      const response = await httpAuth.post(`user/updateMatchStack`, payload);

      if (response.status == 200) {
        if (response?.data?.status) {
          dispatch(getStakesSuccess(response?.data?.data));
          toastr.success("", response.data.msg);
        } else {
          toastr.error("", response.data.msg);
        }
      }
    } else {
      toastr.error("", "Please Login In to Change Stakes");
    }
  } catch (e) {
    toastr.success("", e?.message);
    // return e;
  }

  try {
    const response = await httpAuth.post("/user/getUserMatchStack", {});
    if (response?.data?.status) {
      dispatch(getStakesSuccess(response?.data?.match_stack));
    } else {
      dispatch(getStakesSuccess(StaticStakes));
    }
  } catch (e) {
    dispatch(getStakesSuccess(StaticStakes));
    //   dispatch(getStakesError())
  }
};
